import useMyProfileStore from "@/hooks/useMyProfileStore";
import { useTokenData } from "@/hooks/useTokenData";
import { PAGE_URL } from "@/utils/constants";
import { Button, Card } from "antd";
import Link from "next/link";
import { useMemo } from "react";
import cx from "classnames";
import { upperCase } from "lodash";
import { IoDiamondOutline } from "react-icons/io5";

const ProfileMilestone = () => {
  const {userView} = useMyProfileStore();
  const tokenData = useTokenData();
  const isPremium =  useMemo(() => tokenData?.isPremium === "true",[tokenData]);
  
  if(!isPremium) return null;

  return (
      <Card
        bodyStyle={{paddingTop:0}}
        title={
          <h3 className="font-bold text-lg text-white ">
            My Focused Milestone Category
          </h3>
        }
        actions={[
          userView?.user?.focusedSkillTrack ? (
            <Link href={PAGE_URL.goals}>
              <Button type="text">
                View all milestones
              </Button>
            </Link>
          ) : null,
        ]}
      >
        {userView?.user?.focusedSkillTrack ? (
          <>
            <h3
              className={cx(
                "text-lg font-bold mb-2",
                {
                  "text-red-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "RED",
                },
                {
                  "text-green-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "GREEN",
                },
                {
                  "text-blue-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "BLUE",
                },
                {
                  "text-yellow":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "YELLOW",
                },
              )}
            >
              {
                userView?.user?.focusedSkillTrack
                  ?.department?.name
              }
            </h3>
            <div
              className={cx(
                "pl-4 my-2 border-l-4 py-2",
                {
                  "border-red-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "RED",
                },
                {
                  "border-green-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "GREEN",
                },
                {
                  "border-blue-500":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "BLUE",
                },
                {
                  "border-yellow":
                    upperCase(
                      userView?.user?.focusedSkillTrack
                        ?.color as string,
                    ) === "YELLOW",
                },
              )}
            >
              <p className="text-base font-bold text-white mb-1">
                {userView?.user?.focusedSkillTrack?.name}
              </p>
              <p className="text-sm text-neutral-300 mb-1">
                {userView?.focusedSkill?.description}
              </p>
              <IoDiamondOutline className="text-white text-lg mt-1" />
            </div>
          </>
        ) : (
          <p>There's no focused milestone currently</p>
        )}
      </Card>
  )
}

export default ProfileMilestone;